module.exports = __webpack_public_path__ + "img/ic_enclosure.05445b54.png";